import { createStore } from 'vuex'

import getters from './getters.js'
import actions from './actions.js'
import mutations from './mutations.js'

import wordpressModule from './modules/wordpress/index.js'

const store = createStore({
  modules: {
    wordpress: wordpressModule
  },
  state() {
    return {
      mobileView: false,
      ultrawideView: false,
      mobileLandscape: false,
      scrollD: false,
      menuVisibility: false,
      
    //FIXME Para subir al servidor: cambiar
    //Para local
      // rooturl: "http://localhost/abriendo-el-juego",
      // subcarpeta: "",

     //Para servidor
      // subcarpeta: "tests",
      subcarpeta: "home",
      rooturl: "https://www.abriendoeljuego.ar/",
    
      imageUrl: "/wp-content/plugins/wp-vuecli-plug/dist/img/",
      uploadsUrl: "/wp-content/uploads/",
      menulinks: [
        // Menu de inicio
          {
            ruta: { name: 'inicio', params: { section: 'inicio' } },
            icon: false,
            baseicon: true,
            nombre: "AJ",
            mode: "icon text-5xl",
            viewBox:"0 0 1940 1498",
            color1: "text-amarillo active:text-amarillo",
            color2: "text-azul active:text-azul",
            style: {'--iconTextColor': 'rgba(255, 66, 25, 1)', '--color-hover': ' rgb(89, 79, 169)'}
          },
          {
            ruta: { name: 'nosotrxs', params: { section: 'inicio' }},
            icon: false,
            nombre: "¿Quiénes Somos?",
          },
          {
            ruta: {name: 'inicio', params: { section: 'patas' }},
            icon: false,
            nombre: "Patas",
            mode: "relative flex-col text-center",
            clickMode: 'link',
            clickModeMovil: 'open',
            submenu: true,
            submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
            submode: `p-4 -left-2 rounded-b-card top-7 
                      text-naranja active:text-naranja`,         
            sublinks: [
              {
                ruta: {  name: 'recreacion', params:{ slug: 'recreacion-comunitaria'}},
                icon: false,
                nombre: "LA RECREACIÓN COMUNITARIA",
                style: { fontSize: '10px'},
                mode: " hover:text-azul"                
              },
              {
                ruta: {  name: 'recreacion', params:{ slug: 'la-ludica'} },
                icon: false,
                nombre: "LA LÚDICA, EL JUEGO, EL JUGAR",
                style: { fontSize: '10px'},
                mode: " hover:text-azul"
              },
              {
                ruta: {  name: 'recreacion', params:{ slug: 'educacion-popular'}},
                icon: false,
                nombre: "EDUCACIÓN POPULAR",
                style: { fontSize: '10px'},
                mode: " hover:text-azul"
              },
            ]
          },
          {
            ruta: {name: 'inicio', params: { section: 'novedades' }},
            icon: false,
            nombre: `<p class="text-center">Novedades</p>`,
            mode: " whitespace-normal md:whitespace-nowrap resaltado ",
            // style: {'--color': '#594FA9', '--color-hover': 'white'}
          },
          // {
          //   ruta: { name: 'inicio', params: { section: 'encuentro' }},
          //   icon: false,
          //   nombre: `<p class="text-center">Encuentro</p>`,
          //   isMovilActive: true,          
          // },
          {
            ruta:  { name: 'inicio', params: { section: 'proyectos' } },
            icon: false,
            nombre: "Caminos",
            mode: "relative flex-col text-center",
            submenu: true,
            clickMode: 'link',
            clickModeMovil: 'open',
            submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
            submode: `p-4 -left-2 rounded-b-card top-7 
                      text-naranja active:text-naranja`,         
            sublinks: [],
          },
          // {
          //   ruta: { name: 'inicio', params: { section: 'contacto' } },
          //   icon: false,
          //   nombre: "Contacto"
          // },
          // {
          //   ruta: { name: 'inicio', params: { section: 'espacios' } },
          //   icon: false,
          //   isMovilActive: true,
          //   nombre: `<p class="text-center">Espacios <span class="br-span">amigos</span></p>`
          // },
          {
            ruta: {name: 'inicio', params: { section: 'encuentros' }},
            icon: false,
            nombre: "Encuentros",
            mode: "relative flex-col text-center",
            clickMode: 'open',
            clickModeMovil: 'open',
            submenu: true,
            submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
            submode: `p-4 -left-2 rounded-b-card top-7 
                      text-naranja active:text-naranja`,         
            sublinks: [
              {
                ruta: {  name: 'encuentro2022'},
                icon: false,
                nombre: "ELRCAs 2022",
                style: { fontSize: '10px'},
                mode: " hover:text-azul"                
              },
              {
                ruta: {  name: 'encuentro2024'},
                icon: false,
                nombre: "ELRCAs 2024",
                style: { fontSize: '10px'},
                mode: " hover:text-azul"
              },
              {
                ruta: {  name: 'encuentro2026'},
                icon: false,
                nombre: "ELRCAs 2026",
                style: { fontSize: '10px'},
                mode: " hover:text-azul"
              },
            ]
          },
      ],
      proyectoslinks: [
        // menu de caminos
        {
          ruta: '',
          icon: false,
          fullpath: true,
          baseicon: true,
          nombre: "AJ",
          mode: "icon text-5xl",
          viewBox:"0 0 1940 1498",
          color1: "text-amarillo active:text-amarillo",
          color2: "text-azul active:text-azul",
          style: {'--iconTextColor': 'rgba(255, 66, 25, 1)', '--color-hover': ' rgb(89, 79, 169)'}
        },
        // {
        //   ruta: '/home/encuentro2024/',
        //   nombre: "ELRCAs",
        //   fullpath: true,
        //   baseicon: false,
        //   icon: false,
        //   isMovilActive: true,
        //   mode: "relative flex-col text-center",
        //   submenu: true,          
        //   clickMode: 'link',
        //   submodehover:'bg-white group-hover:inline-block absolute hidden',
        //   submode: `p-4 -left-2 rounded-b-card top-7 
        //             text-naranja active:text-naranja`,   
        //   sublinks: [
        //     {
        //       ruta:'/home/articulos/dispositivos-ludicos-2024',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Dispositivos Lúdicos",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"                 
        //     },
        //     {
        //       ruta:'/home/articulos/paneles-2024',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Paneles",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/feria-de-libros-2024',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Feria de Libros",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/talleres-2024',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Talleres",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/rondas-2024',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Rondas de Socialización",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/tertuludicas-2024',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Tertulúdicas",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"     
        //     },
        //   ]
        // },

        // {
        //   ruta: '/home/encuentro2026/',
        //   nombre: "encuentro2026",
        //   fullpath: true,
        //   baseicon: false,
        //   icon: false,
        //   isMovilActive: true,
        //   mode: "relative flex-col text-center",
        //   submenu: true,          
        //   clickMode: 'link',
        //   submodehover:'bg-white group-hover:inline-block absolute hidden',
        //   submode: `p-4 -left-2 rounded-b-card top-7 
        //             text-naranja active:text-naranja`,   
        //   sublinks: [
        //     {
        //       ruta:'/home/articulos/dispositivos-ludicos-2026',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Dispositivos Lúdicos",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"                 
        //     },
        //     {
        //       ruta:'/home/articulos/paneles-2026',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Paneles",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/feria-de-libros-2026',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Feria de Libros",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/talleres-2026',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Talleres",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/rondas-2026',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Rondas de Socialización",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"    
        //     },
        //     {
        //       ruta:'/home/articulos/tertuludicas-2026',
        //       fullpath: true,
        //       icon: false,
        //       nombre: "Tertulúdicas",
        //       style: { fontSize: '10px'},
        //       mode: " hover:text-azul"     
        //     },
        //   ]
        // },

        {
          ruta: '/quienes-somos/',
          icon: false,
          fullpath: true,
          nombre: "¿Quiénes Somos?",
        },
        {
          ruta: 'patas',
          icon: false,
          nombre: "Patas",
          mode: "relative flex-col text-center",
          submenu: true,          
          clickMode: 'open',
          clickModeMovil: 'open',
          submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
          submode: `p-4 -left-2 rounded-b-card top-7 
                    text-naranja active:text-naranja`,         
          sublinks: [
            // {
            //   ruta: 'recreacion/recreacion-comunitaria',
            //   icon: false,
            //   fullpath: true,
            //   nombre: "LA RECREACIÓN COMUNITARIA",
            //   style: { fontSize: '10px'},
            //   mode: " hover:text-azul"                
            // },
            // {
            //   ruta: 'recreacion/la-ludica',
            //   icon: false,
            //   fullpath: true,
            //   nombre: "LA LÚDICA, EL JUEGO, EL JUGAR",
            //   style: { fontSize: '10px'},
            //   mode: " hover:text-azul"
            // },
            // {
            //   ruta: 'recreacion/educacion-popular',
            //   icon: false,
            //   fullpath: true,
            //   nombre: "EDUCACIÓN POPULAR",
            //   style: { fontSize: '10px'},
            //   mode: " hover:text-azul"
            // },
          ]
        },
        // {
        //   ruta: '/encuentro/',
        //   icon: false,
        //   fullpath: true,
        //   nombre: `<p class="text-center">Encuentro</p>`,
        //   isMovilActive: true,       
        // },
        // {
        //   ruta: '/novedades/',
        //   icon: false,
        //   fullpath: true,
        //   nombre: `<p class="text-center">Novedades</p>`,   
        // },
        {
          ruta: 'caminos',
          icon: false,
          fullpath: true,
          nombre: "Caminos",
          mode: "relative flex-col text-center",
          submenu: true,
          clickMode: 'open',
          clickModeMovil: 'open',
          submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
          submode: `p-4 -left-2 rounded-b-card top-7 
                    text-naranja active:text-naranja`,         
          sublinks: [],
        },
        {
          ruta: {name: 'inicio', params: { section: 'encuentros' }},
          icon: false,
          nombre: "Encuentros",
          mode: "relative flex-col text-center",
          clickMode: 'open',
          clickModeMovil: 'open',
          submenu: true,
          submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
          submode: `p-4 -left-2 rounded-b-card top-7 
                    active:text-azul text-naranja`,         
          sublinks: [
            {
              ruta:'/home/encuentro2022',
              fullpath: true,               
              //ruta: {  name: 'encuentro2022'},
              icon: false,
              nombre: "ELRCAs 2022",
              style: { fontSize: '10px'},
              mode: " hover:text-azul"            
            },
            {
              ruta:'/home/encuentro2024',
              fullpath: true,  
              // ruta: {  name: 'encuentro2024'},
              icon: false,
              nombre: "ELRCAs 2024",
              style: { fontSize: '10px'},
              mode: " hover:text-azul"  
            },
            {
              ruta:'/home/encuentro2026',
              fullpath: true,  
              // ruta: {  name: 'encuentro2026'},
              icon: false,
              nombre: "ELRCAs 2026",
              style: { fontSize: '10px'},
              mode: " hover:text-azul"  
            },
          ]
        },
    ],
    novedadeslinks: [
      // Menu de novedades
      {
        ruta: '',
        icon: false,
        fullpath: true,
        baseicon: true,
        nombre: "AJ",
        mode: "icon text-5xl",
        viewBox:"0 0 1940 1498",
        color1: "text-amarillo active:text-amarillo",
        color2: "text-azul active:text-azul",
        style: {'--iconTextColor': 'rgb(255, 199, 0)', '--color-hover': ' rgb(89, 79, 169)'}
      },
      {
        ruta: '/quienes-somos/',
        icon: false,
        fullpath: true,
        nombre: "¿Quiénes Somos?",
      },
      {
        ruta: 'patas',
        icon: false,
        nombre: "Patas",
        mode: "relative flex-col text-center",
        submenu: true,          
        clickMode: 'open',
        clickModeMovil: 'open',
        submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
        submode: `p-4 -left-2 rounded-b-card top-7 
                  text-naranja active:text-naranja`,         
        sublinks: [
          {
            ruta: 'recreacion/recreacion-comunitaria',
            icon: false,
            fullpath: true,
            nombre: "LA RECREACIÓN COMUNITARIA",
            style: { fontSize: '10px'},
            mode: " hover:text-azul"                
          },
          {
            ruta: 'recreacion/la-ludica',
            icon: false,
            fullpath: true,
            nombre: "LA LÚDICA, EL JUEGO, EL JUGAR",
            style: { fontSize: '10px'},
            mode: " hover:text-azul"
          },
          {
            ruta: 'recreacion/educacion-popular',
            icon: false,
            fullpath: true,
            nombre: "EDUCACIÓN POPULAR",
            style: { fontSize: '10px'},
            mode: " hover:text-azul"
          },
        ]
      },
      // {
      //   ruta: '/encuentro/',
      //   icon: false,
      //   fullpath: true,
      //   nombre: `<p class="text-center">Encuentro</p>`,
      //   isMovilActive: true,       
      // },
      // {
      //   ruta: '/novedades/',
      //   icon: false,
      //   fullpath: true,
      //   nombre: `<p class="text-center">Novedades</p>`,   
      // },
      {
        ruta: 'caminos',
        icon: false,
        fullpath: true,
        nombre: "Caminos",
        mode: "relative flex-col text-center",
        submenu: true,
        clickMode: 'open',
        clickModeMovil: 'open',
        submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
        submode: `p-4 -left-2 rounded-b-card top-7 
                  text-naranja active:text-naranja`,         
        sublinks: [],
      },
      {
          ruta: {name: 'inicio', params: { section: 'encuentros' }},
          icon: false,
          nombre: "Encuentros",
          mode: "relative flex-col text-center",
          clickMode: 'open',
          clickModeMovil: 'open',
          submenu: true,
          submodehover:'group-hover:inline-block group-hover:bg-white absolute hidden',
          submode: `p-4 -left-2 rounded-b-card top-7 
                    active:text-azul text-naranja`,         
          sublinks: [
            {
              ruta:'/home/encuentro2022',
              fullpath: true,  
              // ruta: {  name: 'encuentro2022'},
              icon: false,
              nombre: "ELRCAs 2022",
              style: { fontSize: '10px'},
              mode: " hover:text-azul"                 
            },
            {
              ruta:'/home/encuentro2024',
              fullpath: true,  
              // ruta: {  name: 'encuentro2024'},
              icon: false,
              nombre: "ELRCAs 2024",
              style: { fontSize: '10px'},
              mode: " hover:text-azul"  
            },
            {
              // ruta: {  name: 'encuentro2026'},
              ruta:'/home/encuentro2026',
              fullpath: true,  
              icon: false,
              nombre: "ELRCAs 2026",
              style: { fontSize: '10px'},
              mode: " hover:text-azul"  
            },
          ]
        },
    ],
    encuentrolinks2022: [
        {
          ruta: { name: 'inicio', params: { section: 'inicio' } },
          icon: false,
          baseicon: true,
          nombre: "AJ",
          mode: "icon text-5xl",
          viewBox:"0 0 1940 1498",
          color1: "text-amarillo active:text-amarillo",
          color2: "text-azul active:text-azul",
          style: {'--iconTextColor': 'rgba(255, 66, 25, 1)', '--color-hover': 'white'}
        },
        {
          ruta: { name: 'encuentro2022', params: { section: 'inicio' } },
          icon: false,
          nombre: "Inicio",
        },
        {
          ruta: { name: 'encuentro2022', params: { section: 'recorrido' } },
          icon: false,
          nombre: "Programa",
          mode: "encuentroGroup relative flex-col text-center",
          submenu: true,          
          clickMode: 'link',
          clickModeMovil: 'open',
          submodehover:'bg-naranjaamarillo group-hover:inline-block absolute hidden',
          submode: `p-4 -left-2 rounded-b-card top-7 
                    text-azul active:text-azul submenuEncuentros`,   
          sublinks: [
            {
              ruta:'/home/articulos/dispositivos-ludicos',
              fullpath: true,
              icon: false,
              nombre: "Dispositivos Lúdicos",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"                
            },
            {
              ruta:'/home/articulos/paneles',
              fullpath: true,
              icon: false,
              nombre: "Paneles",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"   
            },
            {
              ruta:'/home/articulos/presentaciones-de-libros-y-revistas',
              fullpath: true,
              icon: false,
              nombre: "Presentaciones de Libros",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"   
            },
            {
              ruta:'/home/articulos/talleres',
              fullpath: true,
              icon: false,
              nombre: "Talleres",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"   
            },
            {
              ruta:'/home/articulos/relatos-de-experiencia',
              fullpath: true,
              icon: false,
              nombre: "Relatos de Experiencia",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"   
            },
            {
              ruta:'/home/articulos/tertulias',
              fullpath: true,
              icon: false,
              nombre: "Tertulias",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"   
            },
          ]        
          // mode: " resaltado ",
            // style: {'--color': 'rgba(255, 66, 25, 1)', '--color-hover': 'white'}
        },
        // {
        //   ruta: { name: 'encuentro2024', params: { section: 'inicio' } },
        //   icon: false,
        //   nombre: "Encuentro 2024",
        // },
        // {
        //   ruta: {name: 'inicio', params: { section: 'inicio' }},
        //   icon: false,
        //   nombre: "Abriendo el juego"
        // },
        {
          ruta: {name: 'inicio', params: { section: 'encuentros' }},
          icon: false,
          nombre: "Encuentros",
          mode: "encuentroGroup relative flex-col text-center",
          clickMode: 'open',
          clickModeMovil: 'open',
          submenu: true,
          submodehover:'group-hover:inline-block group-hover:bg-naranjaamarillo absolute hidden',
          submode: `p-4 -left-2 rounded-b-card top-7 
                    text-azul active:text-naranja submenuEncuentros`,         
          sublinks: [
            {
              ruta:'/home/encuentro2022',
              fullpath: true,  
              // ruta: {  name: 'encuentro2022'},
              icon: false,
              nombre: "ELRCAs 2022",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"                 
            },
            {
              ruta:'/home/encuentro2024',
              fullpath: true,  
              // ruta: {  name: 'encuentro2024'},
              icon: false,
              nombre: "ELRCAs 2024",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"  
            },
            {
              // ruta: {  name: 'encuentro2026'},
              ruta:'/home/encuentro2026',
              fullpath: true,  
              icon: false,
              nombre: "ELRCAs 2026",
              style: { fontSize: '10px'},
              mode: " hover:text-naranja"  
            },
          ]
        },
    ],
    encuentrolinks2024: [
      {
        ruta: { name: 'inicio', params: { section: 'inicio' } },
        icon: false,
        baseicon: true,
        nombre: "AJ",
        mode: "icon text-5xl",
        viewBox:"0 0 1940 1498",
        color1: "text-amarillo active:text-amarillo",
        color2: "text-azul active:text-azul",
        style: {'--iconTextColor': 'rgba(255, 66, 25, 1)', '--color-hover': 'white'}
      },
      {
        ruta: { name: 'encuentro2024', params: { section: 'inicio' } },
        icon: false,
        nombre: "Inicio",
      },
      // {
      //   ruta: { name: 'encuentro2024', params: { section: 'vivo' } },
      //   icon: false,
      //   isMovilActive: true,
      //   nombre: "Vivo",
      //   mode: " resaltado ",
      //   style: {'--color': 'rgba(255, 66, 25, 1)', '--color-hover': 'white'}
      // },
      {
        ruta: {name: 'encuentro2024', params: { section: 'propuesta' }},
        nombre: "Programa",
        icon: false,
        isMovilActive: true,
        mode: "encuentroGroup relative flex-col text-center",
        submenu: true,          
        clickMode: 'link',
        clickModeMovil: 'open',
        submodehover:'bg-naranjaamarillo group-hover:inline-block absolute hidden',
        submode: `p-4 -left-2 rounded-b-card top-7 
                  text-azul active:text-azul submenuEncuentros`,   
        sublinks: [
          {
            ruta:'/home/articulos/dispositivos-ludicos-2024',
            fullpath: true,
            icon: false,
            nombre: "Dispositivos Lúdicos",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"                
          },
          {
            ruta:'/home/articulos/paneles-2024',
            fullpath: true,
            icon: false,
            nombre: "Paneles",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/feria-de-libros-2024',
            fullpath: true,
            icon: false,
            nombre: "Feria de libros",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/talleres-2024',
            fullpath: true,
            icon: false,
            nombre: "Talleres",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/rondas-2024',
            fullpath: true,
            icon: false,
            nombre: "Rondas de Socialización",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/tertuludicas-2024',
            fullpath: true,
            icon: false,
            nombre: "Tertulúdicas",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },          
        ]
      },
      {
        ruta: {name: 'inicio', params: { section: 'encuentros' }},
        icon: false,
        nombre: "Encuentros",
        mode: "encuentroGroup relative flex-col text-center",
        clickMode: 'open',
        clickModeMovil: 'open',
        submenu: true,
        submodehover:'group-hover:inline-block group-hover:bg-naranjaamarillo absolute hidden',
        submode: `p-4 -left-2 rounded-b-card top-7 
                  text-azul active:text-naranja submenuEncuentros`,         
        sublinks: [
          {
            // ruta: {  name: 'encuentro2022'},
            ruta:'/home/encuentro2022',  
            fullpath: true,            
            icon: false,
            nombre: "ELRCAs 2022",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"                 
          },
          {
            // ruta: {  name: 'encuentro2024'},
            ruta:'/home/encuentro2024',  
            fullpath: true,
            icon: false,
            nombre: "ELRCAs 2024",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"  
          },
          {
            // ruta: {  name: 'encuentro2026'},
            ruta:'/home/encuentro2026',  
            fullpath: true,
            icon: false,
            nombre: "ELRCAs 2026",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"  
          },
        ]
    },
      // {
      //   ruta: {name: 'encuentro2024', params: { section: 'propuesta' }},
      //   icon: false,
      //   isMovilActive: true,
      //   nombre: "Propuestas",
      // },
      // {
      //   ruta: { name: 'encuentro2022', params: { section: 'inicio' } },
      //   icon: false,
      //   nombre: "Encuentro 2022",
      // },      
      // {
      //   ruta: {name: 'inicio', params: { section: 'inicio' }},
      //   icon: false,
      //   nombre: "Abriendo el juego"
      // },
    ],
    encuentrolinks2026: [
      {
        ruta: { name: 'inicio', params: { section: 'inicio' } },
        icon: false,
        baseicon: true,
        nombre: "AJ",
        mode: "icon text-5xl",
        viewBox:"0 0 1940 1498",
        color1: "text-amarillo active:text-amarillo",
        color2: "text-azul active:text-azul",
        style: {'--iconTextColor': 'rgba(255, 66, 25, 1)', '--color-hover': 'white'}
      },
      {
        ruta: { name: 'encuentro2026', params: { section: 'inicio' } },
        icon: false,
        nombre: "Inicio",
      },
      // {
      //   ruta: { name: 'encuentro2024', params: { section: 'vivo' } },
      //   icon: false,
      //   isMovilActive: true,
      //   nombre: "Vivo",
      //   mode: " resaltado ",
      //   style: {'--color': 'rgba(255, 66, 25, 1)', '--color-hover': 'white'}
      // },
      {
        ruta: {name: 'encuentro2026', params: { section: 'propuesta' }},
        nombre: "Programa",
        icon: false,
        isMovilActive: true,
        mode: "encuentroGroup relative flex-col text-center",
        submenu: true,          
        clickMode: 'link',
        clickModeMovil: 'open',
        submodehover:'submenuEncuentros bg-naranjaamarillo group-hover:inline-block absolute hidden',
        submode: `p-4 -left-2 rounded-b-card top-7 text-azul active:text-azul`,   
        sublinks: [
          {
            ruta:'/home/articulos/dispositivos-ludicos-2026',
            fullpath: true,
            icon: false,
            nombre: "Dispositivos Lúdicos",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"                
          },
          {
            ruta:'/home/articulos/rondas-de-socializacion-2026',
            fullpath: true,
            icon: false,
            nombre: "Rondas de Socialización",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/recorridos-ludicos-2026',
            fullpath: true,
            icon: false,
            nombre: "Recorridos Lúdicos",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"                
          },
          {
            ruta:'/home/articulos/feria-del-libro-2026',
            fullpath: true,
            icon: false,
            nombre: "Feria del libro",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/talleres-2026',
            fullpath: true,
            icon: false,
            nombre: "Talleres",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },
          {
            ruta:'/home/articulos/experiencias-en-territorios-2026',
            fullpath: true,
            icon: false,
            nombre: "Experiencias en Territorios",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"   
          },          
        ]
      },
      // {
      //   ruta: {name: 'encuentro2026', params: { section: 'inscripcion' }},
      //   nombre: "Inscripción",
      //   icon: false,
      //   isMovilActive: true,
      //   mode: "relative flex-col text-center",
      //   submenu: false,          
      //   clickMode: 'link',
      //   clickModeMovil: 'link',
      //   submodehover:'bg-naranjaamarillo group-hover:inline-block absolute hidden',
      //   submode: `p-4 -left-2 rounded-b-card top-7 
      //             text-azul active:text-azul`, 
      // }, 
      {
        ruta: {name: 'inicio', params: { section: 'encuentros' }},
        icon: false,
        nombre: "Encuentros",
        mode: "encuentroGroup relative flex-col text-center",
        clickMode: 'open',
        clickModeMovil: 'open',
        submenu: true,
        submodehover:'group-hover:inline-block group-hover:bg-naranjaamarillo absolute hidden',
        submode: `p-4 -left-2 rounded-b-card top-7 
                  text-azul active:text-naranja
                  submenuEncuentros`,         
        sublinks: [
          {
            // ruta: {  name: 'encuentro2022'},
            ruta:'/home/encuentro2022',  
            fullpath: true,
            icon: false,
            nombre: "ELRCAs 2022",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"                 
          },
          {
            // ruta: {  name: 'encuentro2024'},
            ruta:'/home/encuentro2024',  
            fullpath: true,
            icon: false,
            nombre: "ELRCAs 2024",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"  
          },
          {
            // ruta: {  name: 'encuentro2026'},
            ruta:'/home/encuentro2026',  
            fullpath: true,
            icon: false,
            nombre: "ELRCAs 2026",
            style: { fontSize: '10px'},
            mode: " hover:text-naranja"  
          },
        ]
    },
      // {
      //   ruta: {name: 'encuentro2024', params: { section: 'propuesta' }},
      //   icon: false,
      //   isMovilActive: true,
      //   nombre: "Propuestas",
      // },
      // {
      //   ruta: { name: 'encuentro2022', params: { section: 'inicio' } },
      //   icon: false,
      //   nombre: "Encuentro 2022",
      // },      
      // {
      //   ruta: {name: 'inicio', params: { section: 'inicio' }},
      //   icon: false,
      //   nombre: "Abriendo el juego"
      // },
    ],
  
    mode: {
      dark: {
        color: 'rgb(255, 255, 255)',
        headerColor: 'rgb(255, 255, 255)',
        colorhober: 'rgb(70, 0, 0)',
        background: 'rgb(252, 65, 32)',
        border: 'rgba(252, 65, 32,0.26)'
      },
      ligth: {
        color: 'rgb(252, 65, 32)',
        headerColor: 'rgb(252, 65, 32)',
        colorhober: 'rgb(185, 43, 0)',
        background: 'transparent',
        border: 'rgba(252, 65, 32,0.26)'
      }, 
      experiencias: {
        color: 'rgb(128,0,128)',
        headerColor: 'rgb(255, 255, 255)',
        colorhober: 'rgb(255, 135, 255)',
        background: 'rgb(128,0,128)',
        border: 'rgba(128,0,128,0.26)'
      },
      juegos: {
        color: 'rgb(46,139,87)',
        headerColor: 'rgb(255, 255, 255)',
        colorhober: 'rgb(180, 255, 213)',
        background: 'rgb(46,139,87)',
        border: 'rgba(46,139,87,0.26)'
      },
      dispositivos: {
        color: 'rgb(0,0,255)',
        headerColor: 'rgb(255, 255, 255)',
        colorhober: ' rgb(156, 156, 252)',
        background: 'rgb(0,0,255)',
        border: 'rgba(0,0,255,0.26)'
      }                 
    }      
    }
  },
  getters,
  actions,
  mutations,
})

export default store

